import { Paper, Stack, Text, Title } from "@mantine/core";
import { IMCBIMAPI } from "@mctypes/mcbim.types";
import React from "react";
import { ScheduleSelector } from "../../../../../components";

const McBimScheduler: React.FC<{
  disabled: boolean;
  onSave: (jobEnabled: boolean, jobInterval: string) => void;
  mcBimProject: IMCBIMAPI.Project;
}> = ({ disabled, onSave, mcBimProject }) => {
  return (
    <Paper withBorder radius="md" p="md">
      <Stack gap="sm">
        <div>
          <Title order={4}>Planlegg synkronisering</Title>
          <Text c="dimmed" size="sm">
          Planlegge hvor ofte synkronisering skal kjøres
          </Text>
        </div>
        <ScheduleSelector
          scheduleActive={mcBimProject.jobEnabled === true && disabled === false}
          onSave={onSave}
          expression={mcBimProject?.jobInterval ?? ""}
          disabled={disabled}
        />
      </Stack>
    </Paper>
  );
};

export default McBimScheduler;
